// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container principal avec marge pour la sidebar - Cohérence parfaite */
.secteur-page-container {
  /* margin-left: 230px; */
  padding: 2rem;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.secteur-page-container h1 {
  color: #1a202c;
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 2rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Header avec recherche et bouton d'ajout - Style identique aux autres */
.secteur-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  gap: 1rem;
  flex-wrap: wrap;
}

.secteur-header input {
  flex: 1 1;
  min-width: 300px;
  padding: 0.875rem 1.25rem;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 1rem;
  background: white;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.secteur-header input:focus {
  outline: none;
  border-color: #4f46e5;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
  transform: translateY(-1px);
}

.secteur-header input::placeholder {
  color: #94a3b8;
}

/* Bouton d'ajout - Style identique aux autres interfaces */
.secteur-btn-add {
  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
  color: white;
  border: none;
  padding: 0.875rem 1.5rem;
  border-radius: 12px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);
  white-space: nowrap;
}

.secteur-btn-add:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(79, 70, 229, 0.4);
}

.secteur-btn-add:active {
  transform: translateY(0);
}

/* Tableau - Style identique aux autres interfaces */
.secteur-table {
  width: 100%;
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  border-collapse: collapse;
}

.secteur-table thead {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.secteur-table thead th {
  padding: 1.25rem 1rem;
  text-align: left;
  font-weight: 600;
  color: white;
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.secteur-table tbody tr {
  border-bottom: 1px solid #f1f5f9;
  transition: all 0.2s ease;
}

.secteur-table tbody tr:hover {
  background: linear-gradient(90deg, #f8fafc 0%, #f1f5f9 100%);
  transform: scale(1.01);
}

.secteur-table tbody tr:last-child {
  border-bottom: none;
}

.secteur-table tbody td {
  padding: 1rem;
  color: #374151;
  font-size: 0.875rem;
  vertical-align: middle;
}

/* Styles spéciaux pour les coordonnées - Plus subtil */
.secteur-table tbody td:nth-child(2),
.secteur-table tbody td:nth-child(3) {
  font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
  font-weight: 500;
  color: #6366f1;
}

/* Boutons d'action - Style identique aux autres */
.secteur-btn-edit,
.secteur-btn-delete {
  background: none;
  border: none;
  padding: 0.5rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #6b7280;
  margin: 0 0.25rem;
}

.secteur-btn-edit:hover {
  background: #f3f4f6;
  transform: scale(1.1);
  color: #3b82f6;
  background: #dbeafe;
}

.secteur-btn-delete:hover {
  background: #f3f4f6;
  transform: scale(1.1);
  color: #ef4444;
  background: #fee2e2;
}

/* Modal overlay - Style identique */
.secteur-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
  animation: secteur-modal-fade-in 0.3s ease;
}

@keyframes secteur-modal-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Modal - Style identique aux autres */
.secteur-modal {
  background: white;
  border-radius: 20px;
  padding: 2rem;
  max-width: 600px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
  animation: secteur-modal-slide-up 0.3s ease;
}

@keyframes secteur-modal-slide-up {
  from {
    transform: translateY(50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.secteur-modal h2 {
  color: #1a202c;
  margin-bottom: 1.5rem;
  font-weight: 700;
  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Formulaire modal - Style identique */
.secteur-modal form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.secteur-modal input {
  padding: 0.875rem;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.2s ease;
  background: white;
}

.secteur-modal input:focus {
  outline: none;
  border-color: #4f46e5;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
}

.secteur-modal input::placeholder {
  color: #9ca3af;
}

/* Actions de modal - Style identique */
.secteur-modal-actions {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  padding-top: 1.5rem;
  border-top: 1px solid #e5e7eb;
}

.secteur-modal-actions button {
  padding: 0.875rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
}

.secteur-modal-actions button[type="submit"] {
  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);
}

.secteur-modal-actions button[type="submit"]:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(79, 70, 229, 0.4);
}

.secteur-modal-actions button[type="button"] {
  background: #f3f4f6;
  color: #374151;
}

.secteur-modal-actions button[type="button"]:hover {
  background: #e5e7eb;
  transform: translateY(-1px);
}

/* Responsive - Identique aux autres */
@media (max-width: 1024px) {
  .secteur-page-container {
    margin-left: 0;
    padding: 1rem;
  }
}

@media (max-width: 768px) {
  .secteur-header {
    flex-direction: column;
    align-items: stretch;
  }

  .secteur-header input {
    min-width: auto;
  }

  .secteur-table {
    font-size: 0.75rem;
  }

  .secteur-table thead th,
  .secteur-table tbody td {
    padding: 0.75rem 0.5rem;
  }

  .secteur-modal {
    padding: 1.5rem;
    margin: 1rem;
  }

  .secteur-modal-actions {
    flex-direction: column;
  }
}

/* Scrollbar personnalisée - Identique */
.secteur-modal::-webkit-scrollbar {
  width: 6px;
}

.secteur-modal::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.secteur-modal::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.secteur-modal::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* États de chargement */
.secteur-table tbody tr.loading {
  opacity: 0.6;
  pointer-events: none;
}

/* Focus visible pour l'accessibilité */
.secteur-btn-add:focus-visible,
.secteur-modal-actions button:focus-visible,
.secteur-header input:focus-visible {
  outline: 2px solid #4f46e5;
  outline-offset: 2px;
}

/* Amélioration de l'accessibilité */
.secteur-btn-edit:focus,
.secteur-btn-delete:focus {
  outline: 2px solid currentColor;
  outline-offset: 2px;
}

/* Animations pour les interactions */
.secteur-table tbody tr,
.secteur-btn-add,
.secteur-modal-actions button,
.secteur-header input {
  will-change: transform;
}

/* Message pour tableau vide */
.secteur-table tbody td[colspan="4"] {
  text-align: center;
  color: #6b7280;
  font-style: italic;
  padding: 2rem;
  background: linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%);
}

/* Conteneur de la carte dans la modal - Style minimal */
.secteur-modal .map-selector-container {
  margin: 1rem 0;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.2s ease;
}

.secteur-modal .map-selector-container:hover {
  border-color: #4f46e5;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Secteurs.css"],"names":[],"mappings":"AAAA,wEAAwE;AACxE;EACE,wBAAwB;EACxB,aAAa;EACb,iBAAiB;EACjB,6DAA6D;EAC7D,uFAAuF;AACzF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,2DAA2D;AAC3D;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,oDAAoD;AACpD;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,4DAA4D;EAC5D,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,uDAAuD;AACvD;;EAEE,wDAAwD;EACxD,gBAAgB;EAChB,cAAc;AAChB;;AAEA,kDAAkD;AAClD;;EAEE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,uCAAuC;AACvC;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,sCAAsC;AACtC;EACE;IACE,cAAc;IACd,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,wCAAwC;AACxC;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA,uCAAuC;AACvC;;;EAGE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;;EAEE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;;;;EAIE,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,6DAA6D;AAC/D;;AAEA,wDAAwD;AACxD;EACE,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":["/* Container principal avec marge pour la sidebar - Cohérence parfaite */\n.secteur-page-container {\n  /* margin-left: 230px; */\n  padding: 2rem;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n}\n\n.secteur-page-container h1 {\n  color: #1a202c;\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin-bottom: 2rem;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* Header avec recherche et bouton d'ajout - Style identique aux autres */\n.secteur-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.secteur-header input {\n  flex: 1;\n  min-width: 300px;\n  padding: 0.875rem 1.25rem;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 1rem;\n  background: white;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.secteur-header input:focus {\n  outline: none;\n  border-color: #4f46e5;\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);\n  transform: translateY(-1px);\n}\n\n.secteur-header input::placeholder {\n  color: #94a3b8;\n}\n\n/* Bouton d'ajout - Style identique aux autres interfaces */\n.secteur-btn-add {\n  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);\n  color: white;\n  border: none;\n  padding: 0.875rem 1.5rem;\n  border-radius: 12px;\n  font-weight: 600;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);\n  white-space: nowrap;\n}\n\n.secteur-btn-add:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(79, 70, 229, 0.4);\n}\n\n.secteur-btn-add:active {\n  transform: translateY(0);\n}\n\n/* Tableau - Style identique aux autres interfaces */\n.secteur-table {\n  width: 100%;\n  background: white;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n  border-collapse: collapse;\n}\n\n.secteur-table thead {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n.secteur-table thead th {\n  padding: 1.25rem 1rem;\n  text-align: left;\n  font-weight: 600;\n  color: white;\n  font-size: 0.875rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.secteur-table tbody tr {\n  border-bottom: 1px solid #f1f5f9;\n  transition: all 0.2s ease;\n}\n\n.secteur-table tbody tr:hover {\n  background: linear-gradient(90deg, #f8fafc 0%, #f1f5f9 100%);\n  transform: scale(1.01);\n}\n\n.secteur-table tbody tr:last-child {\n  border-bottom: none;\n}\n\n.secteur-table tbody td {\n  padding: 1rem;\n  color: #374151;\n  font-size: 0.875rem;\n  vertical-align: middle;\n}\n\n/* Styles spéciaux pour les coordonnées - Plus subtil */\n.secteur-table tbody td:nth-child(2),\n.secteur-table tbody td:nth-child(3) {\n  font-family: \"Monaco\", \"Menlo\", \"Ubuntu Mono\", monospace;\n  font-weight: 500;\n  color: #6366f1;\n}\n\n/* Boutons d'action - Style identique aux autres */\n.secteur-btn-edit,\n.secteur-btn-delete {\n  background: none;\n  border: none;\n  padding: 0.5rem;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: #6b7280;\n  margin: 0 0.25rem;\n}\n\n.secteur-btn-edit:hover {\n  background: #f3f4f6;\n  transform: scale(1.1);\n  color: #3b82f6;\n  background: #dbeafe;\n}\n\n.secteur-btn-delete:hover {\n  background: #f3f4f6;\n  transform: scale(1.1);\n  color: #ef4444;\n  background: #fee2e2;\n}\n\n/* Modal overlay - Style identique */\n.secteur-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  backdrop-filter: blur(4px);\n  animation: secteur-modal-fade-in 0.3s ease;\n}\n\n@keyframes secteur-modal-fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/* Modal - Style identique aux autres */\n.secteur-modal {\n  background: white;\n  border-radius: 20px;\n  padding: 2rem;\n  max-width: 600px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);\n  animation: secteur-modal-slide-up 0.3s ease;\n}\n\n@keyframes secteur-modal-slide-up {\n  from {\n    transform: translateY(50px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.secteur-modal h2 {\n  color: #1a202c;\n  margin-bottom: 1.5rem;\n  font-weight: 700;\n  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* Formulaire modal - Style identique */\n.secteur-modal form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.secteur-modal input {\n  padding: 0.875rem;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 1rem;\n  transition: all 0.2s ease;\n  background: white;\n}\n\n.secteur-modal input:focus {\n  outline: none;\n  border-color: #4f46e5;\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);\n}\n\n.secteur-modal input::placeholder {\n  color: #9ca3af;\n}\n\n/* Actions de modal - Style identique */\n.secteur-modal-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-end;\n  padding-top: 1.5rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n.secteur-modal-actions button {\n  padding: 0.875rem 1.5rem;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: none;\n}\n\n.secteur-modal-actions button[type=\"submit\"] {\n  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);\n  color: white;\n  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);\n}\n\n.secteur-modal-actions button[type=\"submit\"]:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(79, 70, 229, 0.4);\n}\n\n.secteur-modal-actions button[type=\"button\"] {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n.secteur-modal-actions button[type=\"button\"]:hover {\n  background: #e5e7eb;\n  transform: translateY(-1px);\n}\n\n/* Responsive - Identique aux autres */\n@media (max-width: 1024px) {\n  .secteur-page-container {\n    margin-left: 0;\n    padding: 1rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .secteur-header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .secteur-header input {\n    min-width: auto;\n  }\n\n  .secteur-table {\n    font-size: 0.75rem;\n  }\n\n  .secteur-table thead th,\n  .secteur-table tbody td {\n    padding: 0.75rem 0.5rem;\n  }\n\n  .secteur-modal {\n    padding: 1.5rem;\n    margin: 1rem;\n  }\n\n  .secteur-modal-actions {\n    flex-direction: column;\n  }\n}\n\n/* Scrollbar personnalisée - Identique */\n.secteur-modal::-webkit-scrollbar {\n  width: 6px;\n}\n\n.secteur-modal::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 3px;\n}\n\n.secteur-modal::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 3px;\n}\n\n.secteur-modal::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n/* États de chargement */\n.secteur-table tbody tr.loading {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n/* Focus visible pour l'accessibilité */\n.secteur-btn-add:focus-visible,\n.secteur-modal-actions button:focus-visible,\n.secteur-header input:focus-visible {\n  outline: 2px solid #4f46e5;\n  outline-offset: 2px;\n}\n\n/* Amélioration de l'accessibilité */\n.secteur-btn-edit:focus,\n.secteur-btn-delete:focus {\n  outline: 2px solid currentColor;\n  outline-offset: 2px;\n}\n\n/* Animations pour les interactions */\n.secteur-table tbody tr,\n.secteur-btn-add,\n.secteur-modal-actions button,\n.secteur-header input {\n  will-change: transform;\n}\n\n/* Message pour tableau vide */\n.secteur-table tbody td[colspan=\"4\"] {\n  text-align: center;\n  color: #6b7280;\n  font-style: italic;\n  padding: 2rem;\n  background: linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%);\n}\n\n/* Conteneur de la carte dans la modal - Style minimal */\n.secteur-modal .map-selector-container {\n  margin: 1rem 0;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  overflow: hidden;\n  transition: all 0.2s ease;\n}\n\n.secteur-modal .map-selector-container:hover {\n  border-color: #4f46e5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
